module.exports = __webpack_public_path__ + "img/Line 734.4cafe3b8.png";